module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-06-6f7b98fb1b489796d1e9009c57273067.svg";